/**
 * Define a readonly accessor property that will throw error when attempted to write to it
 */
export const defineReadonlyAccessor = (
  object: unknown,
  key: PropertyKey,
  accessor: () => unknown,
  writeError = `${key.toString()} is a readonly accessor property`,
): void => {
  Object.defineProperty(object, key, {
    get: accessor,
    set() {
      throw new Error(writeError);
    },
  });
};
